// Generated by Melange

import * as Curry from "melange.js/curry.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const context = React.createContext(undefined);

const make = context.Provider;

function use(param) {
  return Stdlib__Option.get(React.useContext(context));
}

const Context = {
  context: context,
  make: make,
  use: use
};

function QueueContext$Provider(Props) {
  let children = Props.children;
  const match = React.useState(function () {
    return Stdlib__Fun.$$const(false, undefined);
  });
  const setIsOpen = match[1];
  const isOpen = match[0];
  const value = React.useMemo((function () {
    return {
      isOpen: isOpen,
      setIsOpen: setIsOpen
    };
  }), [isOpen]);
  return JsxRuntime.jsx(make, {
    value: value,
    children: children
  });
}

const Provider = {
  make: QueueContext$Provider
};

function QueueContext$Consumer(Props) {
  const children = Props.children;
  return Curry._1(children, Stdlib__Option.get(React.useContext(context)));
}

const Consumer = {
  make: QueueContext$Consumer
};

export {
  Context,
  Provider,
  Consumer,
}
/* context Not a pure module */
